import {
    atRisk,
    completed,
    exceeded,
    offTrack,
    met,
    partiallyMet,
    nearlyMet,
    onTrack,
    progressed,
} from "../App/components/Dashboard/components/DashboardContent.config";

export const getPercentage = (sect, goalStatuses) => {
    if (goalStatuses && goalStatuses.goals_statuses_count) {
        const sum = goalStatuses.goals_total_count;
        // get the percentage and then trunc the result to the first floating point number
        if (sect === onTrack) {
            return !!sum ? goalStatuses?.goals_statuses_count?.on_track?.percent : sum;
        } else if (sect === atRisk) {
            return !!sum ? goalStatuses?.goals_statuses_count?.at_risk?.percent : sum;
        } else if (sect === offTrack) {
            return !!sum ? goalStatuses?.goals_statuses_count?.off_track?.percent : sum;
        } else if (sect === met) {
            return !!sum ? goalStatuses?.goals_statuses_count?.met?.percent : sum;
        } else if (sect === partiallyMet) {
            return !!sum ? goalStatuses?.goals_statuses_count?.partiallyMet?.percent : sum;
        } else if (sect === nearlyMet) {
            return !!sum ? goalStatuses?.goals_statuses_count?.nearlyMet?.percent : sum;
        } else if (sect === exceeded) {
            return !!sum ? goalStatuses?.goals_statuses_count?.exceeded?.percent : sum;
        } else if (sect === completed) {
            return !!sum ? goalStatuses?.goals_statuses_count?.completed?.percent : sum;
        } else if (sect === progressed) {
            return goalStatuses?.progressed;
        }
    }
}

export const capitalize = (string) =>
    string.charAt(0).toUpperCase() + string.slice(1);

export const capitalizeEachWord = (str = "") =>
    str
        .trim()
        .split(/\s+/) // split by any whitespace
        .map(word => word.length > 0
            ? word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
            : "")
        .join(" ");